<div class="base-input-wrapper" [ngClass]="styleInput">
    <mat-form-field appearance="outline" [ngClass]="{ 'infix-nolabel': !label }">
        @if (!!label) {
        <mat-label>{{ label }}</mat-label>
        }
        <input
            matInput
            [type]="type"
            [placeholder]="placeholder"
            (input)="updateNewValue($event)"
            (blur)="touched()"
            [(ngModel)]="model"
            [required]="required"
            [email]="type === 'email' ? true : false"
            [type]="type"
            porAddFeature
            [featureName]="featureName" />
        @if (icon) {
        <mat-icon matIconPrefix>{{ icon }}</mat-icon>
        } @if (formField.hasError('email')) {
        <mat-error>enter email properly*</mat-error>
        } @if (formField.hasError('required')) {
        <mat-error>required*</mat-error>
        }
    </mat-form-field>
</div>
